import { BillingFormFieldTypes } from '@features/campaigns/details/components/FormFields/FieldTypes.ts';
import { BillingDetailsValues } from '@features/campaigns/details/containers/BillingDetails/BillingDetails.types.ts';
import { Agency, BillingContact } from '@features/campaigns/shared/types/campaign.ts';
import { BillingDetailsPayload } from '@features/campaigns/shared/types/campaignDetails.ts';

export interface BillingDetailsData {
  agency: Agency | null;
  advertiserId: string;
  validFromDate: string;
  validToDate: string;
  billingContact: BillingContact | null;
  purchaseOrder: string | null;
  authorizedBudget?: number | null;
  realBudget?: number | null;
  createdBy: string;
}

export interface AuthorizedBudgetPayload {
  authorizedBudget: number;
}

export interface RealBudgetPayload {
  realBudget: number | null;
}

export function restoreBillingDetailsFormValues({
  agency,
  billingContact,
  purchaseOrder,
  authorizedBudget,
  realBudget,
}: BillingDetailsData): BillingDetailsValues {
  return {
    [BillingFormFieldTypes.AGENCY]: agency?.id,
    [BillingFormFieldTypes.BILLING_CONTACT]: billingContact ? billingContact.id : '',
    [BillingFormFieldTypes.PURCHASE_ORDER]: purchaseOrder || undefined,
    [BillingFormFieldTypes.AUTHORIZED_BUDGET]: authorizedBudget || undefined,
    [BillingFormFieldTypes.REAL_BUDGET]: realBudget || undefined,
  };
}

export function prepareBillingDetailsPayload(
  data: BillingDetailsValues,
  canEditAgency: boolean,
  canEditPurchaseOrder: boolean,
): BillingDetailsPayload {
  return {
    agencyId: canEditAgency ? data.agencyId || null : undefined,
    billingContactId: data.billingContactId,
    purchaseOrder: canEditPurchaseOrder ? data.purchaseOrder : undefined,
  };
}
